module.exports = __webpack_public_path__ + "media/images/features/3/studio-1-977535478c82763a3744d7623b954fc7.png";